<h2 mat-dialog-title>
  {{ "brand.campaign.partners.statusChart.title" | translate }}
</h2>
<mat-dialog-content>
  <div class="loading" *ngIf="vm.state.$type === 'loading'">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
  <div class="message" *ngIf="vm.state.$type === 'error'">
    <p>{{ "shared.errorPerformingTheAction" | translate }}</p>
    <button class="btn btn--transparent" (click)="vm.init()">
      {{ "shared.retry" | translate }}
    </button>
  </div>
  <ng-container *ngIf="vm.state.$type === 'loaded'">
    <div class="charts">
      <app-doughnut-chart-with-legend
        name="brand.campaign.dashboard.engagementLevelsChartTitle"
        [settings]="vm.state.engagementPieChartSettings"
        [legendLines]="vm.state.engagementLegends"
        [totalValue]="vm.state.totalEngagedPartners"
        totalText="brand.campaign.dashboard.totalEngaged"
      />

      <app-doughnut-chart-with-legend
        name="brand.campaign.dashboard.partnerStatusChartTitle"
        [settings]="vm.state.partnerStatusPieChartSettings"
        [legendLines]="vm.state.partnerStatusLegends"
        [totalValue]="vm.state.totalPartners"
        totalText="brand.campaign.dashboard.totalPartners"
      />
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn--primary" [mat-dialog-close]="">
    {{ "shared.close" | translate }}
  </button>
</mat-dialog-actions>
